import { InjectionToken } from '@angular/core';
import type { Signal } from '@angular/core';

export interface StepIdSignal {
  (): string | number | undefined;
  set(value: string | number | undefined): void;
}

export interface StepsHost {
  steps: Signal<ReadonlyArray<unknown>>;
  activeStepId: StepIdSignal;
  activeStepIndex: Signal<number>;
  disabled: Signal<boolean>;
  getStepsCount(): number;
  setActiveStepById(id: string | number): void;
}

export const STEPS_HOST = new InjectionToken<StepsHost>('stepsHost');
